import { createContext, useContext } from "react";
export const MailScopeContext = createContext("outside-mail-session");
export const useMailScope = () => useContext(MailScopeContext);
